import { render, staticRenderFns } from "./CircularChar.vue?vue&type=template&id=55a34630&scoped=true"
import script from "./CircularChar.vue?vue&type=script&lang=js"
export * from "./CircularChar.vue?vue&type=script&lang=js"
import style0 from "./CircularChar.vue?vue&type=style&index=0&id=55a34630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a34630",
  null
  
)

export default component.exports